export type LocationName = 'hamburg' | 'berlin' | 'lehrte' | 'gerau' | 'muenchen';

export const locations: Record<LocationName, string> = {
  berlin: 'Berlin',
  gerau: 'Groß-Gerau bei Frankfurt a. M.',
  hamburg: 'Hamburg',
  lehrte: 'Lehrte bei Hannover',
  muenchen: 'München',
};